module.exports = __webpack_public_path__ + "static/media/ecom.1cffbce9.png";